import type {ComponentType} from 'react';

import type {PillProps} from 'shells/acorn-pill/pill-wrapper';
import {Button} from 'shells/button/button';
import {SaveButton} from 'shells/button/save-button/save-button';
import {Card} from 'shells/card/card';
import {Stack} from 'shells/layout/stack/stack';
import {LoadingText} from 'shells/loading-placeholder/loading-text';
import {Body} from 'shells/typography/body';

const PILL_HEIGHT = 32;

export type ExpiredTrialActionCardCta =
    | {
          type: 'save';
          label: string;
          onClick: () => Promise<unknown>;
          savingText?: string;
          successText?: string;
          isSaving?: boolean;
          didFail?: boolean;
          disabled?: boolean;
      }
    | {
          type: 'action';
          label: string;
          onClick: () => void | Promise<unknown>;
          isLoading?: boolean;
          disabled?: boolean;
      };

interface Props {
    pill: ComponentType<PillProps>;
    body: string;
    isLoadingBody?: boolean;
    cta: ExpiredTrialActionCardCta;
}

export function ExpiredTrialActionCard(props: Props) {
    const Pill = props.pill;

    return (
        <Card hasBorder={true} fitContent={false} fitHeight={true} borderRadius={8}>
            <div className='pad-16'>
                <Stack spacing={16} alignItems='start'>
                    <Pill height={PILL_HEIGHT} />
                    {props.isLoadingBody ? (
                        <LoadingText isFullWidth={true} height={15} />
                    ) : (
                        <Body size='normal'>{props.body}</Body>
                    )}
                    {props.cta.type === 'save' ? (
                        <SaveButton
                            variant='primary'
                            size='big'
                            buttonText={props.cta.label}
                            savingText={props.cta.savingText ?? 'Saving'}
                            successText={props.cta.successText ?? 'Success!'}
                            isSaving={Boolean(props.cta.isSaving)}
                            errorSaving={Boolean(props.cta.didFail)}
                            disabled={props.cta.disabled}
                            onClick={props.cta.onClick}
                            resetOnComplete={true}
                        />
                    ) : (
                        <Button
                            variant='primary'
                            size='big'
                            onClick={props.cta.onClick}
                            disabled={props.cta.disabled || props.cta.isLoading}
                        >
                            {props.cta.label}
                        </Button>
                    )}
                </Stack>
            </div>
        </Card>
    );
}
